// extracted by mini-css-extract-plugin
export default {"tile-badge":"yourofferskfrkIs","tile-badge__label":"youroffersfnMpje","tile-badge__label--super-offer":"youroffersNpOr25"};